import API from "./axios";

const invoiceApi = {
  listL1:        (status) => API.get("/invoices/level1" + (status ? `?status=${status}` : "")),
  // Phase 36da.9 — DBI (Direct Bill Invoice) variants for the dedicated
  // Direct Bill Ledger page.  Same shape as L1/L2 helpers.
  listDbi:       (status) => API.get("/invoices/dbi" + (status ? `?status=${status}` : "")),
  /** Phase 5 — paged register listings. */
  pagedL1:       (params) => API.get("/invoices/paged/level1", { params }),
  pagedDbi:      (params) => API.get("/invoices/paged/dbi", { params }),
  // Phase 36da.99.schol — combined Scholar register (L1 DC-invoices + DBI
  // direct-bill invoices) with a section filter ("ALL" | "DC" | "DIRECT_BILL").
  pagedScholar:  (params) => API.get("/invoices/paged/scholar", { params }),
  scholarStats:  (params) => API.get("/invoices/stats/scholar", { params }),
  getById:       (id)     => API.get(`/invoices/${id}`),
  recordPayment: (id, d)  => API.post(`/invoices/${id}/payments`, d),
  cancel:        (id)     => API.patch(`/invoices/${id}/cancel`),
  // Phase 36da.10 — DBI ledger now goes through its own endpoint
  // (/ledger/dbi/{partyId}) so the backend can apply DIRECT_BILL_LEDGER
  // permission instead of INVOICE_REGISTER.  L1 / L2 continue to use
  // the level-keyed legacy path.
  partyLedger:   (level, partyId) =>
    "DBI".toUpperCase() === String(level).toUpperCase()
      ? API.get(`/invoices/ledger/dbi/${partyId}`)
      : API.get(`/invoices/ledger/${level}/${partyId}`),
  receiptPdf:    (invoiceId, paymentId) => API.get(`/invoices/${invoiceId}/payments/${paymentId}/receipt`, { responseType: "blob" }),
  // Phase 36da.55 — pass through the page's current search/from/to so the
  // Excel mirrors the on-screen register exactly (instead of always
  // exporting the full level-wide list).
  exportExcel:   (level, status, q, from, to, invFrom, invTo) => API.get(`/invoices/export/${level}`, {
    params: {
      status:   status && status !== "ALL" ? status : undefined,
      q:        q   || undefined,
      fromDate: from || undefined,
      toDate:   to   || undefined,
      // Same reason as exportBulkSizeWise — the Inv# range is a screen filter
      // the server never saw.
      invFrom:  invFrom || undefined,
      invTo:    invTo   || undefined,
    },
    responseType: "blob",
  }),
  getSettings:   ()       => API.get("/invoices/settings"),
  updateSettings: (d)     => API.put("/invoices/settings", d),
  ageingReport:  (level)  => API.get(`/invoices/ageing/${level}`),

  // ── Size-wise export endpoints ────────────────────────────────────────
  exportSingleExcel: (id)  => API.get(`/invoices/${id}/export/excel`, { responseType: "blob" }),
  // Phase 36da.55 — added `q` so size-wise export also matches search filter.
  // invFrom/invTo — the register's Inv# range. It filters CLIENT-SIDE, so
  // without these the export returned the whole date range while the table
  // showed the filtered rows.
  exportBulkSizeWise: (level, from, to, status, q, invFrom, invTo) => API.get(`/invoices/export/sizewise/${level}`, {
    params: {
      from:   from || undefined,
      to:     to   || undefined,
      status: status && status !== "ALL" ? status : undefined,
      q:      q    || undefined,
      invFrom: invFrom || undefined,
      invTo:   invTo   || undefined,
    },
    responseType: "blob",
  }),

  // Phase 36da.68 — overall totals (count + invoiced + received + outstanding)
  // for the Invoice Register summary cards.  Same filter shape as exportExcel
  // so the cards stay consistent with the Excel and bulk ZIP exports.
  getStats: (level, status, q, from, to) => API.get(`/invoices/stats/${level}`, {
    params: {
      status:   status && status !== "ALL" ? status : undefined,
      q:        q    || undefined,
      fromDate: from || undefined,
      toDate:   to   || undefined,
    },
  }),

  // Phase 36da.64 — bulk PDF download as ZIP, filtered by the same params
  // the register Excel uses.  Returns application/zip.  Backend may take
  // a while for large filter sets (one PDF generated per matching invoice);
  // frontend should show a loading indicator.
  exportZip: (level, status, q, from, to) => API.get(`/invoices/export/zip/${level}`, {
    params: {
      status:   status && status !== "ALL" ? status : undefined,
      q:        q    || undefined,
      fromDate: from || undefined,
      toDate:   to   || undefined,
    },
    responseType: "blob",
    // Long-running call: bump axios timeout if it's set lower globally.
    timeout: 600000, // 10 minutes
  }),
};

export default invoiceApi;